import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Supplier} from '../../../Models/Supplier';
import {SupplierService} from '../../../Services/supplier.service';
import {HttpParams} from '@angular/common/http';
import {Subject, Observable, of, concat, BehaviorSubject} from 'rxjs';
import {distinctUntilChanged, debounceTime, switchMap, tap, catchError, filter} from 'rxjs/operators';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {Helper} from '../../../../helpers/helper.service';

@Component({
  selector: 'app-supplier-overview',
  templateUrl: './supplier-overview.component.html',
  styleUrls: ['./supplier-overview.component.scss']
})
export class SupplierOverviewComponent implements OnInit {
  public grid: Grid;
  public supplierId: number;
  public supplierName: string;
  public selectedSupplier: Supplier;
  public suppliers: Observable<Supplier[]>;
  public suppliersLoading = false;
  public suppliersinput$ = new Subject<string>();
  public refreshGrid = new BehaviorSubject(1);
  @ViewChild('supplierRowDetail', {static: false}) supplierRowDetail: any;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(private router: Router, private supplierService: SupplierService, private translate: TranslateService, private broadcastService: BroadcastService) {
  }

  ngOnInit() {
    this.loadSupplier();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.supplier.number',
          prop: 'number',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.supplier.companyName',
          prop: 'companyName',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.supplier.email',
          prop: 'email',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.supplier.phone',
          prop: 'phone',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.supplier.status',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translate.instant('global.active');
            }
            return this.translate.instant('global.inactive');
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('back-office/supplier/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            < ActionItem > {
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/supplier/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.supplierId = row.id;
                this.supplierName = row.companyName.bold();
                this.deleteModal.show();
                // return this.router.navigateByUrl('back-office/supplier/' + row.id + '/show');
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.supplierService,
      rememberURL: this.router.url,
      method: 'getSupplier',
      defaultSort: 'name',
      rowDetailTemplate: this.supplierRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true
    };
  }

  public softDelete() {
    this.supplierService.softDeleteSupplier(this.supplierId, this.selectedSupplier.id).subscribe((res) => {
      this.deleteModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getSupplier');
    });
  }

  private loadSupplier() {
    let params = new HttpParams();
    this.suppliers = concat(
      of([]), // default items
      this.suppliersinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        filter(query => query && query.length > 2),
        tap(() => {this.suppliersLoading = true; params = params.append('excludeValue', this.supplierId.toString());}),
        switchMap((term) => this.supplierService.getSupplierReplace(params.set('query', term)).pipe(
          catchError(() => of([])), // empty list on error
          tap((res) => {
            this.suppliersLoading = false;
          })
        ))
      )
    );
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/supplier/archive');

  }
}
